import { createSlice } from '@reduxjs/toolkit'

export interface IDashboardStateInterface {
    isLoading: boolean,
    error: string,
    success: string,
    loginCredentialsScreenType: any,
    notificationSettings: any,
    reportProblemDetails: any
}

const initialState: IDashboardStateInterface = {
    isLoading: false,
    error: '',
    success: '',
    loginCredentialsScreenType: 1,
    notificationSettings: [],
    reportProblemDetails: {
        screenshots: [],
        description: "",
    }
}

export const helpAndSupportRedux = createSlice({
    name: 'helpAndSupportRedux',
    initialState,
    reducers: {
        setHelpAndSupportState: (state: any, action: any) => {
            const newState = {
                ...state,
            }
            newState[action.payload.key] = action.payload.value
            return newState
        },

        setLoginCredentialsScreenType: (state: any, action: any) => {
            const newState = {
                ...state,
            }
            newState["loginCredentialsScreenType"] = action.payload
            return newState
        },
    },
})

export const {
    setHelpAndSupportState,
    setLoginCredentialsScreenType,
} = helpAndSupportRedux.actions

export default helpAndSupportRedux.reducer
